import React, { useMemo } from 'react';
import { Icon } from 'semantic-ui-react';
import styles from './PaymentList.module.scss';
import numeral from 'numeral';
import moment from 'moment';
import PaymentWarnings from './PaymentWarnings';

export const PaymentListTypeAccount = 0;
export const PaymentListTypePolicy = 1;

const PaymentList = ({ paymentListType, subjects }) => {
	return (
		<div className={styles.list}>
			<div className={styles.headerRow}>
				<div className={`${styles.header}`}>
					{paymentListType === PaymentListTypeAccount && 'Account'}
					{paymentListType === PaymentListTypePolicy && 'Policy'}
				</div>
				<div className={styles.content}>
					<div className={`${styles.column} ${styles.center} ${styles.mobileHidden}`}></div>
					<div className={`${styles.column} ${styles.center}`}>{paymentListType === PaymentListTypeAccount ? 'Policies' : ''}</div>
					<div className={`${styles.column} ${styles.right}`}>Current Payment Due</div>
					<div className={`${styles.mobileHidden} ${styles.column} ${styles.right}`}>Last Payment</div>
					<div className={`${styles.mobileHidden} ${styles.column} ${styles.right}`}>To Pay In Full</div>
				</div>
			</div>
			{subjects.map((subject, i) => {
				return <PaymentListItem key={i} subject={subject} type={paymentListType} />;
			})}
		</div>
	);
};

const PaymentListItem = ({ subject, type }) => {
	const { current, future, header } = subject;

	const icon = useMemo(() => {
		const prefix = header.substring(0, 3);
		var iconType = '';
		switch (prefix) {
			case 'PPA':
				iconType = 'car';
				break;
			case 'HOM':
			case 'PIM':
			case 'PUP':
			case 'DFR':
				iconType = 'home';
				break;
			case 'FAR':
			case 'FUP':
				iconType = 'barn';
				break;
			case 'ACC':
				iconType = '';
				break;
			default:
				iconType = 'open-sign';
				break;
		}

		if (iconType !== '') {
			return (
				<div className={styles.icon}>
					<Icon name={iconType} size='large' verticalAlign='middle' />
				</div>
			);
		}

		return null;
	}, [header]);

	return (
		<div className={styles.row}>
			<div className={`${styles.header} ${future ? styles.future : null}`}>
				{icon}
				{header}
			</div>
			<div className={styles.content}>
				<div className={styles.itemGroups}>
					{<PaymentListSubItemGroup {...current} showDescription={!!future} includePolicyNumber={type === PaymentListTypeAccount} includeMetadata={type === PaymentListTypePolicy} />}
					{future && <PaymentListSubItemGroup {...future} isFuture showDescription={true} includePolicyNumber={type === PaymentListTypeAccount} includeMetadata={type === PaymentListTypePolicy} />}
				</div>
			</div>
		</div>
	);
};

const PaymentListSubItemGroup = ({ subItems, isFuture, description, showDescription, total, ...rest }) => {
	return (
		<div className={styles.subItemGroup}>
			<div className={`${styles.subHeader}`}>
				{showDescription
					? description.map((d) => {
							return <div>{d}</div>;
					  })
					: ''}
			</div>
			<div className={styles.mobileHidden}></div>
			<div className={styles.subItemGroupItems}>
				{subItems &&
					subItems.map((policy, i) => {
						return <PaymentListSubItem policy={policy} key={i} {...rest} />;
					})}

				{!subItems && <PaymentListSubItem policy={rest} {...rest} />}

				{total && <PaymentListSubItem policy={total} isTotal includeMetadata />}
			</div>
		</div>
	);
};

const PaymentListSubItem = ({ policy, includePolicyNumber, includeMetadata, isTotal }) => {
	const { billing } = policy;
	const { outstandingBalance, outstandingBalanceDueDate, payInFullAmount, lastPayment } = billing;

	return (
		<div className={`${styles.subItem} ${isTotal ? styles.totalItem : ''}`}>
			{isTotal ? <div className={`${styles.column} ${styles.center}`}>Total</div> 
					 : <div className={`${styles.column} ${styles.center}`}>{includePolicyNumber ? policy.policyNumber : ''}</div>}
			<div className={`${styles.column} ${styles.right}`}>
				<div>{`${numeral(Math.max(outstandingBalance < 1 ? 0 : outstandingBalance, 0)).format('$ 0,0.00')}`}</div>
				{includeMetadata && Math.max(outstandingBalance, 0) >= 1 && (
					<div>
						<PaymentWarnings isPastDue={policy.isPastDue} isSoonDue={policy.isSoonDue} />
						{`due ${moment(outstandingBalanceDueDate).format('L')}`}
					</div>
				)}
			</div>
			<div className={`${styles.mobileHidden} ${styles.column} ${styles.right}`}>
				{!policy.isFuture && lastPayment && (
					<>
						<div>{`${numeral(lastPayment.paymentAmount).format('$ 0,0.00')}`}</div>
						{includeMetadata && lastPayment.paymentAmount ? <div>{`paid ${moment(lastPayment.itemDate).format('L')}`}</div> : null}
					</>
				)}
			</div>
			<div className={`${styles.mobileHidden} ${styles.column} ${styles.right}`}>
				<div>{`${numeral(payInFullAmount).format('$ 0,0.00')}`}</div>
			</div>
		</div>
	);
};

export default PaymentList;
